import { clearSession, readSession, writeSession } from '../api/session-store';
import { login, logout } from '../api/panel-api';

export { readSession };

export async function signIn(email, password) {
  const data = await login(email, password);
  const session = {
    accessToken: data.access_token,
    refreshToken: data.refresh_token,
    expiresIn: data.expires_in,
    user: data.user,
  };
  writeSession(session);
  return session;
}

export async function signOut() {
  const session = readSession();
  clearSession();
  if (!session) return;
  try {
    await logout(session.refreshToken);
  } catch {
    // Выход идемпотентен: локальная сессия уже снята.
  }
}
